import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import DateTime from 'react-datetime';
import Loader from 'react-loader';
import { Button, FormGroup, ControlLabel, Checkbox } from 'react-bootstrap';
import { Row, Col, Tab, Nav, NavItem } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import { handleError } from '../../shared/ErrorCatching';
import FormSelect from '../../components/common/FormSelect';
import * as Site from '../../shared/Site';
import CustomerInvoicablesList from './CustomerInvoicablesList';
import SellerInvoicablesList from './SellerInvoicablesList';
import CustomerInvoiceModal from './CustomerInvoiceModal';
import * as actions from './InvoiceActions';
import { getSiteName } from '../../shared/Site';
import moment from 'moment';

class InvoicePage extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);
        this.state = {
            invoiceInterval: 0,
            shownTab: 1,
            invoiceDate: new Date(),
            filter: {
                selectedCountry: props.user.details.country
            },
            searched: false,
            showingInvoice: false,
            invoiceToShowBrokerFirmId: null,
            invoiceToShowInvoiceChecksum: null,
            searchLoading: false,
            selectedItems: []
        };

        this.onDateTimeChange = this.onDateTimeChange.bind(this);
        this.onRegionChange = this.onRegionChange.bind(this);
        this.onBrokerChainChange = this.onBrokerChainChange.bind(this);
        this.onLegalEntityChange = this.onLegalEntityChange.bind(this);
        this.onCountryChange = this.onCountryChange.bind(this);
        this.search = this.search.bind(this);
        this.showTab = this.showTab.bind(this);
        this.showInvoiceByBrokerFirm = this.showInvoiceByBrokerFirm.bind(this);
        this.showInvoiceByInvoiceChecksum = this.showInvoiceByInvoiceChecksum.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onSiteChanged = this.onSiteChanged.bind(this);
        this.onInvoiceIntervalChange = this.onInvoiceIntervalChange.bind(this);
        this.handleSelectedItemsChange = this.handleSelectedItemsChange.bind(this);
    }

    componentDidMount(): void {
        this.props.actions
            .getInvoicablesFilter()
            .then(this.loadFilterFromLocalStorage())
            .catch((error: any) => handleError(error));
    }

    showInvoiceByBrokerFirm(brokerFirmId: number, invoiceCheckSum: number): void {
        this.setState({
            showingInvoice: true,
            invoiceToShowBrokerFirmId: brokerFirmId,
            invoiceToShowInvoiceChecksum: invoiceCheckSum
        });
    }

    showInvoiceByInvoiceChecksum(invoiceToShowInvoiceChecksum: number): void {
        this.setState({
            showingInvoice: true,
            invoiceToShowBrokerFirmId: null,
            invoiceToShowInvoiceChecksum: invoiceToShowInvoiceChecksum
        });
    }

    closeModal(reload: boolean = false) {
        this.setState({ showingInvoice: false });
        if (reload) {
            this.search();
        }
    }

    showTab(shownTab: number): void {
        this.setState({ shownTab });
    }

    onDateTimeChange(moment: any): void {
        this.setState({ invoiceDate: moment ? moment.toDate() : null });
    }

    onRegionChange(e: any): void {
        let filter = {
            ...this.state.filter,
            selectedRegionId: e.target.value
        };

        this.setState({ filter }, () => this.saveFilterToLocalStorage());
    }
    onInvoiceIntervalChange(e: any): void {
        let filter = {
            ...this.state.filter,
            invoiceInterval: e.target.value
        };

        this.setState({ filter }, () => this.saveFilterToLocalStorage());
    }

    onBrokerChainChange(e: any): void {
        let filter = {
            ...this.state.filter,
            selectedBrokerChainId: e.target.value
        };

        this.setState({ filter }, () => this.saveFilterToLocalStorage());
    }

    onLegalEntityChange(e: any): void {
        let filter = {
            ...this.state.filter,
            selectedLegalEntityId: e.target.value
        };

        this.setState({ filter }, () => this.saveFilterToLocalStorage());
    }

    onSiteChanged(e: any): void {
        let filter = {
            ...this.state.filter,
            site: e.target.value
        };

        this.setState({ filter }, () => this.saveFilterToLocalStorage());
    }

    onCountryChange(e: any): void {
        let filter = {
            ...this.state.filter,
            selectedCountry: parseInt(e.target.value),
            selectedRegionId: '',
            selectedBrokerChainId: ''
        };
        this.setState({ filter }, () => this.saveFilterToLocalStorage());
    }

    search(): void {
        this.setState({ searchLoading: true });

        this.props.actions
            .getInvoicables(
                this.state.filter.selectedRegionId,
                this.state.filter.selectedBrokerChainId,
                this.state.filter.selectedCountry,
                this.state.filter.selectedLegalEntityId,
                this.state.filter.site, 
                this.state.filter.invoiceInterval
            )
            .then(() => this.setState({ searched: true, searchLoading: false }))
            .catch((error: any) => handleError(error));
    }

    saveFilterToLocalStorage = () => {
        localStorage.setItem('invoiceFilter', JSON.stringify(this.state.filter));
    };

    loadFilterFromLocalStorage = () => {
        let filter = JSON.parse(localStorage.getItem('invoiceFilter'));
        if (filter !== null) {
            this.setState({ filter });
        }
    };

    handleSelectedItemsChange(selectedItems: any[]): void {
        this.setState({ selectedItems });
    }

    saveSelected(): void {
        this.setState({ searchLoading: true });
    
        this.props.actions
            .saveSelected(this.state.selectedItems, this.state.invoiceDate, this.props.user.details.languageKey)
            .then(() => {
                this.setState({ searched: true, searchLoading: false })
                this.search();
            })
            .catch((error: any) => {
                handleError(error);
                this.search();
            });
    }

    render() {
        return (
            <div>
                <h1 className="col-xs-12">{Translate('invoice/title/invoice')}</h1>
                <fieldset>
                    <Row>
                        <Col md={3} sm={6}>
                            <FormGroup>
                                <ControlLabel>{Translate('invoice/filter/country')}</ControlLabel>
                                <FormSelect
                                    name="country"
                                    value={
                                        this.state.filter.selectedCountry
                                            ? (this.state.filter.selectedCountry as any)
                                            : undefined
                                    }
                                    onChange={this.onCountryChange}
                                >
                                    <option value="" />
                                    {this.props.filter.availableCountries.map((s: any) => {
                                        return (
                                            <option key={s.id} value={s.id as any}>
                                                {Translate(s.name)}
                                            </option>
                                        );
                                    })}
                                </FormSelect>
                            </FormGroup>
                        </Col>
                        <Col md={3} sm={6}>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('broker-firm/form/invoice-interval')}
                                </ControlLabel>
                                <FormSelect
                                    name="invoiceInterval"
                                    onChange={this.onInvoiceIntervalChange}
                                >
                                    <option value="" />
                                    <option value={1 as number}>
                                        {Translate('broker-firm/form/billing-mid-month')}
                                    </option>
                                </FormSelect>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3} sm={6}>
                            <FormGroup>
                                <ControlLabel>{Translate('invoice/filter/region')}</ControlLabel>
                                <FormSelect
                                    name="region"
                                    value={this.state.filter.selectedRegionId as any}
                                    onChange={this.onRegionChange}
                                >
                                    <option value="" />
                                    {this.props.filter.availableRegions
                                        .filter(
                                            (s: any) =>
                                                !this.state.filter.selectedCountry ||
                                                this.state.filter.selectedCountry === s.country
                                        )
                                        .map((s: any) => {
                                            return (
                                                <option key={s.id} value={s.id as any}>
                                                    {s.name}
                                                </option>
                                            );
                                        })}
                                </FormSelect>
                            </FormGroup>
                        </Col>

                        <Col md={3} sm={6}>
                            <FormGroup>
                                <ControlLabel>{Translate('invoice/filter/chain')}</ControlLabel>
                                <FormSelect
                                    name="brokerChain"
                                    value={this.state.filter.selectedBrokerChainId as any}
                                    onChange={this.onBrokerChainChange}
                                >
                                    <option value="" />
                                    {this.props.filter.availableBrokerChains
                                        .filter(
                                            (s: any) =>
                                                !this.state.filter.selectedCountry ||
                                                this.state.filter.selectedCountry === s.country
                                        )
                                        .map((s: any) => {
                                            return (
                                                <option key={s.id} value={s.id as any}>
                                                    {s.name}
                                                </option>
                                            );
                                        })}
                                </FormSelect>
                            </FormGroup>
                        </Col>
                        <Col md={3} sm={6}>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('invoice/filter/legal-entity')}
                                </ControlLabel>
                                <FormSelect
                                    name="legalEntity"
                                    value={this.state.filter.selectedLegalEntityId as any}
                                    onChange={this.onLegalEntityChange}
                                >
                                    <option value="" />
                                    {this.props.filter.availableLegalEntities.map((s: any) => {
                                        return (
                                            <option key={s.id} value={s.id as any}>
                                                {s.name}
                                            </option>
                                        );
                                    })}
                                </FormSelect>
                            </FormGroup>
                        </Col>
                        {this.props.site !== getSiteName(Site.Zentuvo) ?
                            <Col md={3} sm={6}>
                                <FormGroup>
                                    <ControlLabel>{Translate('invoice/filter/site')}</ControlLabel>
                                        <FormSelect
                                            name="site"
                                            value={this.state.filter.site as any}
                                            onChange={this.onSiteChanged}
                                        >
                                            <option value="" />
                                            <option value={Site.SE360 as any}>
                                                {Translate('invoice/filter/site/se360')}
                                            </option>
                                            <option value={Site.Scandphotos as any}>
                                                {Translate('invoice/filter/site/scandphotos')}
                                            </option>
                                        </FormSelect>
                                </FormGroup>
                            </Col> 
                        : null}
                        <Col md={12}>
                            <Button
                                bsSize="large"
                                disabled={this.state.searchLoading}
                                onClick={() => this.search()}
                                bsStyle="success"
                            >
                                {Translate('invoice/search')}
                            </Button>
                        </Col>
                    </Row>
                </fieldset>
                <Loader loaded={!this.state.searchLoading}>
                    {this.state.searched && (
                        <Row>
                            <Col md={3}>
                                <FormGroup>
                                    <ControlLabel>
                                        {Translate('invoice/filter/invoice-date')}
                                    </ControlLabel>
                                    <DateTime
                                        locale={moment.locale()}
                                        value={this.state.invoiceDate}
                                        timeFormat={false}
                                        onChange={this.onDateTimeChange}
                                        closeOnSelect={true}
                                    />
                                    <Button
                                        bsSize="small"
                                        disabled={this.state.searchLoading}
                                        onClick={() => this.saveSelected()}
                                        bsStyle="primary"
                                        style={{ marginTop: '5px' }} // Adjust margin to align with DateTime
                                    >
                                        {Translate('invoice/save-selected-button')}
                                    </Button>                                    
                                </FormGroup>
                            </Col>
                        </Row>
                    )}
                    {this.state.searched && (
                        <Row>
                            <Col md={12}>
                                <Tab.Container defaultActiveKey={1} id="uncontrolled-tab">
                                    <div>
                                        <Nav bsStyle="tabs">
                                            <NavItem onClick={() => this.showTab(1)} eventKey={1}>
                                                {Translate('invoice/tab-titles/brokers') +
                                                    ` (${this.props.invoicables.invoicableBrokerFirms.length})`}
                                            </NavItem>
                                            <NavItem onClick={() => this.showTab(2)} eventKey={2}>
                                                {Translate('invoice/tab-titles/brokers-separate') +
                                                    ` (${this.props.invoicables.invoicableBrokerFirmsWithSeperateInvoiceReceiver.length})`}
                                            </NavItem>
                                            <NavItem onClick={() => this.showTab(3)} eventKey={3}>
                                                {Translate('invoice/tab-titles/sellers') +
                                                    ` (${this.props.invoicables.invoicableSellers.length})`}
                                            </NavItem>
                                            <NavItem onClick={() => this.showTab(4)} eventKey={4}>
                                                {Translate('invoice/tab-titles/commercial') +
                                                    ` (${this.props.invoicables.invoicableCompanies.length})`}
                                            </NavItem>
                                            <NavItem onClick={() => this.showTab(5)} eventKey={5}>
                                                {Translate(
                                                    'invoice/tab-titles/commercial-separate'
                                                ) +
                                                    ` (${this.props.invoicables.invoicableCompaniesWithSeperateInvoiceReceiver.length})`}
                                            </NavItem>
                                        </Nav>
                                        <Tab.Content id="view-invoicables-tabs">
                                            <Tab.Pane eventKey={1}>
                                                <CustomerInvoicablesList
                                                    items={
                                                        this.props.invoicables.invoicableBrokerFirms
                                                    }
                                                    pendingInvoices={this.props.invoicables.pendingInvoices.filter(
                                                        (invoice: any) => {
                                                            return (
                                                                invoice.customerType &&
                                                                invoice.customerType.value === 1 &&
                                                                (invoice.invoiceReceiverType
                                                                    .value === 1 ||
                                                                    invoice.invoiceReceiverType
                                                                        .value === 2 ||
                                                                    invoice.invoiceReceiverType
                                                                        .value === 4) &&
                                                                !invoice.invoiceReceiverSeparateBillingAddress
                                                            );
                                                        }
                                                    )}
                                                    showInvoice={this.showInvoiceByBrokerFirm}
                                                    tryInvoiceAgain={
                                                        this.props.actions.tryInvoiceAgain
                                                    }
                                                    onSelectedItemsChange={this.handleSelectedItemsChange}
                                                />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey={2}>
                                                <CustomerInvoicablesList
                                                    items={
                                                        this.props.invoicables
                                                            .invoicableBrokerFirmsWithSeperateInvoiceReceiver
                                                    }
                                                    pendingInvoices={this.props.invoicables.pendingInvoices.filter(
                                                        (invoice: any) => {
                                                            return (
                                                                invoice.customerType &&
                                                                invoice.customerType.value === 1 &&
                                                                (invoice.invoiceReceiverType
                                                                    .value === 1 ||
                                                                    invoice.invoiceReceiverType
                                                                        .value === 2 ||
                                                                    invoice.invoiceReceiverType
                                                                        .value === 4) &&
                                                                invoice.invoiceReceiverSeparateBillingAddress
                                                            );
                                                        }
                                                    )}
                                                    showInvoice={this.showInvoiceByBrokerFirm}
                                                    tryInvoiceAgain={
                                                        this.props.actions.tryInvoiceAgain
                                                    }
                                                    onSelectedItemsChange={this.handleSelectedItemsChange}
                                                />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey={3}>
                                                <SellerInvoicablesList
                                                    items={this.props.invoicables.invoicableSellers}
                                                    pendingInvoices={this.props.invoicables.pendingInvoices.filter(
                                                        (invoice: any) => {
                                                            return (
                                                                invoice.customerType &&
                                                                invoice.customerType.value === 1 &&
                                                                invoice.invoiceReceiverType
                                                                    .value === 3
                                                            );
                                                        }
                                                    )}
                                                    showInvoice={this.showInvoiceByInvoiceChecksum}
                                                    tryInvoiceAgain={
                                                        this.props.actions.tryInvoiceAgain
                                                    }
                                                    onSelectedItemsChange={this.handleSelectedItemsChange}
                                                />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey={4}>
                                                <CustomerInvoicablesList
                                                    items={
                                                        this.props.invoicables.invoicableCompanies
                                                    }
                                                    pendingInvoices={this.props.invoicables.pendingInvoices.filter(
                                                        (invoice: any) => {
                                                            return (
                                                                invoice.customerType &&
                                                                invoice.customerType.value === 2 &&
                                                                (invoice.invoiceReceiverType
                                                                    .value === 1 ||
                                                                    invoice.invoiceReceiverType
                                                                        .value === 2 ||
                                                                    invoice.invoiceReceiverType
                                                                        .value === 4) &&
                                                                !invoice.invoiceReceiverSeparateBillingAddress
                                                            );
                                                        }
                                                    )}
                                                    showInvoice={this.showInvoiceByBrokerFirm}
                                                    tryInvoiceAgain={
                                                        this.props.actions.tryInvoiceAgain
                                                    }
                                                    onSelectedItemsChange={this.handleSelectedItemsChange}
                                                />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey={5}>
                                                <SellerInvoicablesList
                                                    items={
                                                        this.props.invoicables
                                                            .invoicableCompaniesWithSeperateInvoiceReceiver
                                                    }
                                                    pendingInvoices={this.props.invoicables.pendingInvoices.filter(
                                                        (invoice: any) => {
                                                            return (
                                                                invoice.customerType &&
                                                                invoice.customerType.value === 2 &&
                                                                (invoice.invoiceReceiverType
                                                                    .value === 1 ||
                                                                    invoice.invoiceReceiverType
                                                                        .value === 2 ||
                                                                    invoice.invoiceReceiverType
                                                                        .value === 4) &&
                                                                invoice.invoiceReceiverSeparateBillingAddress
                                                            );
                                                        }
                                                    )}
                                                    showInvoice={this.showInvoiceByInvoiceChecksum}
                                                    tryInvoiceAgain={
                                                        this.props.actions.tryInvoiceAgain
                                                    }
                                                    onSelectedItemsChange={this.handleSelectedItemsChange}
                                                />
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </div>
                                </Tab.Container>
                            </Col>
                        </Row>
                    )}
                </Loader>
                {this.state.showingInvoice && (
                    <CustomerInvoiceModal
                        invoiceToShowInvoiceChecksum={this.state.invoiceToShowInvoiceChecksum}
                        invoiceToShowBrokerFirmId={this.state.invoiceToShowBrokerFirmId}
                        invoiceDate={this.state.invoiceDate}
                        closeModal={this.closeModal}
                        onSearch={this.search}
                    />
                )}
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        languageKey: state.user.details.languageKey,
        user: state.user,
        filter: state.invoices.filter,
        invoicables: state.invoices.invoicables,
        site: state.site
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getInvoicablesFilter: () => dispatch(actions.getInvoicablesFilter()),
            getInvoicables: (
                regionId: number,
                brokerChainId: number,
                country: number,
                legalEntityId: number,
                site: number,
                invoiceInterval: number
            ) =>
                dispatch(
                    actions.getInvoicables(regionId, brokerChainId, country, legalEntityId, site, invoiceInterval)
                ),
            tryInvoiceAgain: (invoiceId: number) => dispatch(actions.tryInvoiceAgain(invoiceId)),
            saveSelected: (selectedItems: any[], invoiceDate: any, languageKey: string) => dispatch(actions.createInvoices(selectedItems, invoiceDate, languageKey))
        }
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InvoicePage));
